import Layout from '@/layout'

const route = {
  path: '/newLaunchGroup',
  component: Layout,
  redirect: '/newLaunchGroup/index',
  alwaysShow: true, // will always show the root menu
  name: 'newLaunchGroup',
  meta: {
    title: '快应用报表',
    icon: 'CRRM',
    roles: [
      'channel_release_report.managent'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/newLaunchGroup/releaseGroupList/index',
      component: () => import('@/views/newLaunchGroup/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          'channel_release_group.index'
        ]
      }
    },
    {
      path: '/newLaunchGroup/bookOwnership/index',
      component: () => import('@/views/newLaunchGroup/bookOwnership/index.vue'),
      name: 'bookOwnership',
      meta: {
        title: '书籍归属列表',
        icon: 'component',
        roles: [
          'channel_release_report.belong_list'
        ]
      }
    },
    {
      path: '/newLaunchGroup/dropLocationList/index',
      component: () => import('@/views/newLaunchGroup/dropLocationList/index.vue'),
      name: 'dropLocationList',
      meta: {
        title: '投放位置列表',
        icon: 'component',
        roles: [
          'channel_positions.index'
        ]
      }
    },
    {
      path: '/newLaunchGroup/bindingRelationList/index',
      component: () => import('@/views/newLaunchGroup/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          'bind_channel.index'
        ]
      }
    }, {
      path: '/newLaunchGroup/reportList/index',
      component: () => import('@/views/newLaunchGroup/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '报表列表',
        icon: 'component',
        roles: [
          'channel_release_report.bind_channel_report'
        ]
      }
    }, {
      path: '/newLaunchGroup/totalReportList/index',
      component: () => import('@/views/newLaunchGroup/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计报表',
        icon: 'component',
        roles: [
          'channel_release_report.bind_channel_total_report'
        ]
      }
    }, {
      path: '/newLaunchGroup/reportForm/index',
      component: () => import('@/views/newLaunchGroup/reportForm/index.vue'),
      name: 'reportForm',
      meta: {
        title: 'T图列表',
        icon: 'component',
        roles: [
          'channel_release_report.bind_channel_t_report'
        ]
      }
    }
  ]
}

export default route
